//server
//production
const API_URL = "https://cpo.aeidth.com/";

//server
//development
// const API_URL = "https://demo.techxinnovations.in";
//local
// const API_URL = "http://192.168.1.150:8000/";

export {API_URL};